
import React, { memo, useEffect, useState } from "react";
import CustomdropDown from "./customdropDown";
import axios from "axios";
import { Grid } from "@mui/material";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../hooks/snackBar/reducers";

const Country = ({ formik, countryId }) => {
  const dispatch = useDispatch()
  const [countryList, setCountryList] = useState([]);
  const getCountryList = () => {
    axios
      .get("/v1/countries")
      .then((res) => {
        setCountryList(res.data);
        // _.filter(res.data,val=>val.id=== countryId).map(val=>formik.setFieldValue('country', val))
      })
      .catch((err) => {
        dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
      });
  };
  useEffect(() => {
    getCountryList();
  }, []);
  console.log(countryList.length , countryId)

  useEffect(()=>{    
    console.log('first')
    _.filter(countryList, val=>val.id=== countryId).map(val=>formik.setFieldValue('country', val))

  },[formik.values, countryId, countryList])
  return (
    <Grid>
      <CustomdropDown
        id="country"
        data={countryList}
        optionLabel={(option) => option.name}
        value={formik.values.country}
        onchange={(e, value) => {
          formik.setFieldValue("country", value);
        }}
        optionEqual={(option, value) => option.name === value.name}
        placeholder="Select country"
        helperText={formik.touched.country && formik.errors.country}
        errorMsg={formik.touched.country && Boolean(formik.errors.country)}
        title="Country *"
      />
    </Grid>
  );
};

export default memo(Country);
